var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("studip-wizard-dialog", {
    attrs: {
      title: _vm.$gettext("Lernmaterial kopieren"),
      confirmText: _vm.$gettext("Kopieren"),
      closeText: _vm.$gettext("Abbrechen"),
      lastRequiredSlotId: 2,
      requirements: _vm.requirements,
      slots: _vm.wizardSlots,
    },
    on: {
      close: _vm.close,
      confirm: _vm.copy,
    },
    scopedSlots: _vm._u([
      {
        key: "source",
        fn: function fn() {
          return [
            _c(
              "form",
              {
                staticClass: "default",
                on: {
                  submit: function submit($event) {
                    $event.preventDefault()
                  },
                },
              },
              [
                _c(
                  "fieldset",
                  {
                    staticClass: "radiobutton-set",
                  },
                  [
                    _vm.inCourseContext
                      ? [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.source,
                                expression: "source",
                              },
                            ],
                            attrs: {
                              id: "cw-shelf-copy-source-self",
                              type: "radio",
                              value: "self",
                              "aria-description": _vm.text.sourceSelf,
                            },
                            domProps: {
                              checked: _vm._q(_vm.source, "self"),
                            },
                            on: {
                              change: function change($event) {
                                _vm.source = "self"
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              attrs: {
                                for: "cw-shelf-copy-source-self",
                              },
                              on: {
                                click: function click($event) {
                                  _vm.source = "self"
                                },
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "icon",
                                },
                                [
                                  _c("studip-icon", {
                                    attrs: {
                                      shape: "seminar",
                                      size: 32,
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "text",
                                },
                                [_vm._v(_vm._s(_vm.text.sourceSelf))]
                              ),
                              _vm._v(" "),
                              _c("studip-icon", {
                                staticClass: "unchecked",
                                attrs: {
                                  shape: "radiobutton-unchecked",
                                  size: 24,
                                },
                              }),
                              _vm._v(" "),
                              _c("studip-icon", {
                                staticClass: "check",
                                attrs: {
                                  shape: "check-circle",
                                  size: 24,
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.source,
                          expression: "source",
                        },
                      ],
                      attrs: {
                        id: "cw-shelf-copy-source-courses",
                        type: "radio",
                        value: "courses",
                        "aria-description": _vm.text.sourceCourses,
                      },
                      domProps: {
                        checked: _vm._q(_vm.source, "courses"),
                      },
                      on: {
                        change: function change($event) {
                          _vm.source = "courses"
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        attrs: {
                          for: "cw-shelf-copy-source-courses",
                        },
                        on: {
                          click: function click($event) {
                            _vm.source = "courses"
                          },
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "icon",
                          },
                          [
                            _c("studip-icon", {
                              attrs: {
                                shape: "seminar",
                                size: 32,
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "text",
                          },
                          [_vm._v(_vm._s(_vm.text.sourceCourses))]
                        ),
                        _vm._v(" "),
                        _c("studip-icon", {
                          staticClass: "unchecked",
                          attrs: {
                            shape: "radiobutton-unchecked",
                            size: 24,
                          },
                        }),
                        _vm._v(" "),
                        _c("studip-icon", {
                          staticClass: "check",
                          attrs: {
                            shape: "check-circle",
                            size: 24,
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.source,
                          expression: "source",
                        },
                      ],
                      attrs: {
                        id: "cw-shelf-copy-source-users",
                        type: "radio",
                        value: "users",
                        "aria-description": _vm.text.sourceUsers,
                      },
                      domProps: {
                        checked: _vm._q(_vm.source, "users"),
                      },
                      on: {
                        change: function change($event) {
                          _vm.source = "users"
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        attrs: {
                          for: "cw-shelf-copy-source-users",
                        },
                        on: {
                          click: function click($event) {
                            _vm.source = "users"
                          },
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "icon",
                          },
                          [
                            _c("studip-icon", {
                              attrs: {
                                shape: "content",
                                size: 32,
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "text",
                          },
                          [_vm._v(_vm._s(_vm.text.sourceUsers))]
                        ),
                        _vm._v(" "),
                        _c("studip-icon", {
                          staticClass: "unchecked",
                          attrs: {
                            shape: "radiobutton-unchecked",
                            size: 24,
                          },
                        }),
                        _vm._v(" "),
                        _c("studip-icon", {
                          staticClass: "check",
                          attrs: {
                            shape: "check-circle",
                            size: 24,
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  2
                ),
                _vm._v(" "),
                _vm.source === "courses"
                  ? [
                      _c("label", [
                        _c("span", [_vm._v(_vm._s(_vm.$gettext("Semester")))]),
                        _c("span", {
                          attrs: {
                            "aria-hidden": "true",
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.selectedSemester,
                                expression: "selectedSemester",
                              },
                            ],
                            on: {
                              change: function change($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function (o) {
                                    return o.selected
                                  })
                                  .map(function (o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.selectedSemester = $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              },
                            },
                          },
                          [
                            _c(
                              "option",
                              {
                                attrs: {
                                  value: "all",
                                },
                              },
                              [_vm._v(_vm._s(_vm.$gettext("Alle Semester")))]
                            ),
                            _vm._v(" "),
                            _vm._l(_vm.semesterMap, function (semester) {
                              return _c(
                                "option",
                                {
                                  key: semester.id,
                                  domProps: {
                                    value: semester.id,
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(semester.attributes.title) +
                                      "\n                        "
                                  ),
                                ]
                              )
                            }),
                          ],
                          2
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "label",
                        [
                          _c("span", [
                            _vm._v(_vm._s(_vm.$gettext("Veranstaltung"))),
                          ]),
                          _c(
                            "span",
                            {
                              staticClass: "wizard-required",
                              attrs: {
                                "aria-hidden": "true",
                              },
                            },
                            [_vm._v("*")]
                          ),
                          _vm._v(" "),
                          _vm.filteredCourses.length !== 0 &&
                          !_vm.loadingCourses
                            ? _c("studip-select", {
                                attrs: {
                                  options: _vm.filteredCourses,
                                  clearable: false,
                                  reduce: function reduce(option) {
                                    return option.id
                                  },
                                  getOptionLabel: function getOptionLabel(
                                    option
                                  ) {
                                    return option.attributes.title
                                  },
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "open-indicator",
                                      fn: function fn(selectAttributes) {
                                        return [
                                          _c(
                                            "span",
                                            _vm._b(
                                              {},
                                              "span",
                                              selectAttributes,
                                              false
                                            ),
                                            [
                                              _c("studip-icon", {
                                                attrs: {
                                                  shape: "arr_1down",
                                                  size: 10,
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  3553876404
                                ),
                                model: {
                                  value: _vm.selectedRange,
                                  callback: function callback($$v) {
                                    _vm.selectedRange = $$v
                                  },
                                  expression: "selectedRange",
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.loadingCourses
                            ? _c("p", [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(
                                      _vm.$gettext("Lade Veranstaltungen…")
                                    ) +
                                    "\n                    "
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.filteredCourses.length === 0 &&
                          !_vm.loadingCourses
                            ? _c("p", [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(
                                      _vm.$gettext(
                                        "Es wurden keine geeigneten Veranstaltungen gefunden."
                                      )
                                    ) +
                                    "\n                    "
                                ),
                              ])
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]
                  : _vm._e(),
              ],
              2
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "unit",
        fn: function fn() {
          return [
            _c(
              "form",
              {
                staticClass: "default",
                on: {
                  submit: function submit($event) {
                    $event.preventDefault()
                  },
                },
              },
              [
                _vm.units.length !== 0
                  ? _c(
                      "fieldset",
                      {
                        staticClass: "radiobutton-set",
                      },
                      [
                        _vm._l(_vm.units, function (unit) {
                          var _domProps
                          return [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.selectedUnit,
                                  expression: "selectedUnit",
                                },
                              ],
                              key: "radio-" + unit.id,
                              attrs: {
                                id: "cw-shelf-copy-unit-" + unit.id,
                                type: "radio",
                                "aria-description":
                                  unit.element.attributes.title,
                              },
                              domProps:
                                ((_domProps = {
                                  checked: unit.id === _vm.selectedUnitId,
                                  value: unit,
                                }),
                                (_domProps["checked"] = _vm._q(
                                  _vm.selectedUnit,
                                  unit
                                )),
                                _domProps),
                              on: {
                                change: function change($event) {
                                  _vm.selectedUnit = unit
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                key: "label-" + unit.id,
                                attrs: {
                                  for: "cw-shelf-copy-unit-" + unit.id,
                                },
                                on: {
                                  click: function click($event) {
                                    _vm.selectedUnit = unit
                                  },
                                },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "icon",
                                  },
                                  [
                                    _c("studip-icon", {
                                      attrs: {
                                        shape: "courseware",
                                        size: 32,
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "text",
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(unit.element.attributes.title)
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("studip-icon", {
                                  staticClass: "unchecked",
                                  attrs: {
                                    shape: "radiobutton-unchecked",
                                    size: 24,
                                  },
                                }),
                                _vm._v(" "),
                                _c("studip-icon", {
                                  staticClass: "check",
                                  attrs: {
                                    shape: "check-circle",
                                    size: 24,
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        }),
                      ],
                      2
                    )
                  : _c("courseware-companion-box", {
                      attrs: {
                        mood: "sad",
                        msgCompanion: _vm.$gettext(
                          "Für die gewählte Quelle stehen keine Lernmaterialien zur Verfügung."
                        ),
                      },
                    }),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "edit",
        fn: function fn() {
          return [
            _vm.selectedUnit
              ? _c(
                  "form",
                  {
                    staticClass: "default",
                    on: {
                      submit: function submit($event) {
                        $event.preventDefault()
                      },
                    },
                  },
                  [
                    _c("label", [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$gettext("Titel")) +
                          "\n                "
                      ),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.modifiedTitle,
                            expression: "modifiedTitle",
                          },
                        ],
                        attrs: {
                          type: "text",
                          placeholder: _vm.selectedUnitTitle,
                          name: "title",
                        },
                        domProps: {
                          value: _vm.modifiedTitle,
                        },
                        on: {
                          input: function input($event) {
                            if ($event.target.composing) return
                            _vm.modifiedTitle = $event.target.value
                          },
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c(
                      "label",
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.$gettext("Farbe")) +
                            "\n                "
                        ),
                        _c("studip-select", {
                          attrs: {
                            options: _vm.colors,
                            reduce: function reduce(color) {
                              return color.class
                            },
                            clearable: false,
                            label: "name",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "open-indicator",
                                fn: function fn(selectAttributes) {
                                  return [
                                    _c(
                                      "span",
                                      _vm._b(
                                        {},
                                        "span",
                                        selectAttributes,
                                        false
                                      ),
                                      [
                                        _c("studip-icon", {
                                          attrs: {
                                            shape: "arr_1down",
                                            size: 10,
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "no-options",
                                fn: function fn() {
                                  return [
                                    _vm._v(
                                      "\n                        " +
                                        _vm._s(
                                          _vm.$gettext(
                                            "Es steht keine Auswahl zur Verfügung."
                                          )
                                        ) +
                                        "\n                    "
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                              {
                                key: "selected-option",
                                fn: function fn(option) {
                                  return [
                                    _c("span", {
                                      staticClass: "vs__option-color",
                                      style: {
                                        "background-color": option.hex,
                                      },
                                    }),
                                    _c("span", [_vm._v(_vm._s(option.name))]),
                                  ]
                                },
                              },
                              {
                                key: "option",
                                fn: function fn(option) {
                                  return [
                                    _c("span", {
                                      staticClass: "vs__option-color",
                                      style: {
                                        "background-color": option.hex,
                                      },
                                    }),
                                    _c("span", [_vm._v(_vm._s(option.name))]),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            2594175929
                          ),
                          model: {
                            value: _vm.modifiedColor,
                            callback: function callback($$v) {
                              _vm.modifiedColor = $$v
                            },
                            expression: "modifiedColor",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("label", [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$gettext("Beschreibung")) +
                          "\n                "
                      ),
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.modifiedDescription,
                            expression: "modifiedDescription",
                          },
                        ],
                        attrs: {
                          placeholder: _vm.selectedUnitDescription,
                        },
                        domProps: {
                          value: _vm.modifiedDescription,
                        },
                        on: {
                          input: function input($event) {
                            if ($event.target.composing) return
                            _vm.modifiedDescription = $event.target.value
                          },
                        },
                      }),
                    ]),
                  ]
                )
              : _c("courseware-companion-box", {
                  attrs: {
                    mood: "pointing",
                    msgCompanion: _vm.$gettext(
                      "Bitte wählen Sie ein Lernmaterial aus."
                    ),
                  },
                }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }